import { getGlobal } from "@/functions/getGlobal";
import classes from "./styles.module.scss";
import { blogs_helper } from "@/helpers/blogs_helper";
import Hero from "@/components/Hero";
import SeoHead from "@/components/SeoHead";
import { BlogSection, FormSection } from "@/components";
import Title from "@/ui/Title";
import Body from "@/ui/Body";
import Image from "@/ui/Image";
import { consultant_helper } from "@/helpers/consultant_helper";
import { convertDateFormat } from "@/functions/formatDate";

export default function BlogPage({ title, canonical, blog, blogs }) {

  const global = getGlobal();

  const consultants = consultant_helper.fetch({filter: (i) => (i.name?.toLowerCase() == blog.published_by?.toLowerCase())});
  const consultant = consultants.length > 0 ? consultants[0] : null;

  const page = {
    background: {
      path: blog.image
    },
    subtitle: {
      path: "blog.subtitle",
      placeholder: "Blog",
    },
    title: {
      path: "blog.title",
      placeholder: blog.title,
    },
    relatedTitle: {
      path: "blog.related.title",
      placeholder: "Continue reading",
    },
    relatedSubtitle: {
      path: "blog.related.subtitle",
      placeholder: "Related blogs",
    },
    formTitle: {
      path: "blog.form.title",
      placeholder: "Subscribe now",
    }
  }

  function generateBlogType(blogType) {
    if(typeof blogType === 'string') {
      return <Title title={blogType} className={classes.blog_type} tag="h6" />
    } else if(Array.isArray(blogType)) {
      return <div className={classes.blog_types}>
        {
          blogType.map((_item, index) => {
            return <Title key={index} title={_item} className={classes.blog_type} tag="h6" />
          })
        }
      </div>
    } else {
      return "-"
    }
  }

  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <Hero alt={blog.title} background={blog.image} title={page.title} subtitle={page.subtitle} />
      <div className={classes.cont}>
        <div className={classes.content}>
          <div className={classes.left_cont}>
            <div className={classes.inner_cont}>
              <div className={classes.detail}>
                <Title title={`BLOG TYPE`} className={`caption ${classes.label}`} tag="div" />
                {generateBlogType(blog.blog_type)}
              </div>
              <div className={classes.detail}>
                <Title title={`DATE PUBLISHED`} className={`caption ${classes.label}`} tag="div" />
                <Title title={convertDateFormat(blog.publish_date)} className={classes.value} tag="h6" />
              </div>
              {
                consultant &&
                <div className={classes.detail}>
                  <Title title={`AUTHOR`} className={`caption ${classes.label}`} tag="div" />
                  <div className={classes.author}>
                    <Image img={consultant.profile_image} size="200x200" alt={consultant.name} className={classes.image} />
                    <Title title={consultant.name} className={classes.consultant_name} tag="h6" />
                    <Title title={consultant.position_title} className={classes.position} tag="div" />
                  </div>
                </div>
              }
              {
                !consultant &&
                <div className={classes.detail}>
                  <Title title={`AUTHOR`} className={`caption ${classes.label}`} tag="div" />
                  <Title title={blog.published_by} className={classes.consultant_name} tag="h6" />
                </div>
              }
            </div>
          </div>
          <div className={classes.right_cont}>
            <Body body={blog.description} className={`body1 ${classes.body}`} />
          </div>
        </div>
      </div>
      <BlogSection title={page.relatedTitle} blogs={blogs} subtitle={page.relatedSubtitle} />
      <FormSection title={page.formTitle} variant="dark" formId="b41f1561-7b8d-41cf-ae20-2924ccf90a66" redirect_url="/" />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const blog = blogs_helper.find(url_slug);
  const blogs = blogs_helper.fetch({limit: 2});

  return {
    props: {
      title: blog.title,
      canonical: `/blogs/${url_slug}/`,
      blog,
      url_slug,
      blogs,
    },
  };
}

export async function getStaticPaths() {
  return { paths: blogs_helper.toPaths(), fallback: false };
}
